import { type Middleware } from '@reduxjs/toolkit';

import { datadogRum } from '@datadog/browser-rum';
import type { RootState } from 'store';

import { fetchUser } from 'dux/user/thunks';

/**
 * Middleware to handle Datadog RUM features
 * For now:
 * - User identification
 *
 * And we can later on integrate:
 * - Custom events
 * - Performance monitoring
 * - Error tracking
 */
const datadogMiddleware: Middleware<unknown, RootState> = () => (next) => (action) => {
  // Handle user identification
  if (fetchUser.fulfilled.match(action)) {
    const { payload } = action;
    datadogRum?.setUser({
      id: payload?.pubkey,
    });
  }

  return next(action);
};

export default datadogMiddleware;
